// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/home-lines.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-48 {
    width: 48%;
}

.text-capitalize {
    text-transform: capitalize;
}

.no-visible {
    visibility: hidden;
}

.no-resize {
    resize: none;
}

.overflow-hidden {
    overflow: hidden;
}

.overflow-x-scroll {
    overflow-x: scroll;
}

.invisible {
    visibility: hidden;
}

.clip-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    width: calc(100%);
    -webkit-hyphens: auto;
    hyphens: auto;
}

.clamp-2 {
    -webkit-line-clamp: 2;
}

.description-word-length {
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 12px;
}

.overflow-wrap-anywhere {
    overflow-wrap: anywhere;
}

.whitespace-nowrap {
    white-space: nowrap;
}

/* ----- CHECKBOX ----- */

.checkbox-wrap {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    user-select: none;
}

.checkbox-wrap input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 9px;
    width: 9px;
    background-color: #fff;
    border: 1px solid #000000;
    border-radius: 2px;
}

/* On mouse-over, add a grey background color */

.checkbox-wrap:hover input~.checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */

.checkbox-wrap input:checked~.checkmark {
    background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */

.checkbox-wrap input:checked~.checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */

.checkbox-wrap .checkmark:after {
    left: 9px;
    top: 5px;
    width: 3px;
    height: 5px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

/* --- MANAGE BENEFICIARIES */

.kuda-beneficiary--card {
    max-width: 533px !important;
    margin-left: auto;
    margin-right: auto;
}

.beneficairy-info--wrap {
    max-width: 380px;
    display: flex;
    margin: auto;
    flex-direction: column;
}

.beneficiary-history {
    border-top: 1px solid rgba(5, 96, 117, 0.08);
    padding-right: 0;
    margin-top: 34px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    position: relative;
}

.beneficiary-profile-image {
    width: 80px;
    height: 80px;
    display: flex;
    background-size: cover;
    background-color: #e8e8e8;
    border-radius: 100px;
    margin-bottom: 10px;
}

.no-beneficiary-msg {
    font-size: 20px;
    text-align: center;
    margin-top: 92px;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
}

.beneficiary-transactions--loaderWrap {
    margin-top: 30px;
    margin-bottom: 30px;
}

.beneficiary-loader--wrap {
    margin-top: 50px;
}

.beneficiary-loader {
    top: auto;
    top: initial;
}

thead th {
    color: #979797 !important;
}

.analytics-transaction--details p {
    max-width: 335px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
}

.kuda-signatory--table td {
    font-size: 0.875rem;
}

.kuda-signatory--table td:last-child {
    padding-right: 15px;
}

.no-left {
    left: 0 !important;
}

.schedule-item {
    width: 100%;
}

.schedule-time-wrap {
    height: 46px;
    margin-top: 3px;
}

.schedule-time--dropdown {
    display: flex;
    align-items: center;
    height: 100%;
    border-right: 1px solid #dfe3ff;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 0 10px;
}

.schedule-dropdown--title {
    font-size: 12px;
    padding-right: 0px;
    padding-left: 5px;
}

.scheduleTime-dropdown-icon,
.scheduleTime-dropdown-header,
.schedule-dropdown--title {
    width: fit-content !important;
}

.schedule-time--wrap {
    width: 145px;
    max-width: 145px;
}

.scheduleTime-dropdown-list {
    max-width: 62px;
    /* background: transparent; */
}

.schedule-time-input {
    width: 70px;
}

.schedule-time-input input {
    width: 25px;
    border: none;
    outline: none;
}

.width-fit-content {
    width: fit-content !important;
}

.onboarding-info--wrap {
    max-width: 560px;
    /* margin: 0 auto; */
    width: 100%;
}

.card-display--bio {
    background: #ffffff;
    border: 1px solid #dfe3ff !important;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06) !important;
    border-radius: 4px;
    height: 100%;
    width: 100%;
    max-width: 356px;
    padding: 21px 30px;
    margin-top: 2.375rem;
    margin-bottom: 1.875rem;
}

.onboarding-avatar {
    width: 70px;
    height: 70px;
    min-width: 70px;
    background: #dfe4ff;
}

.border-outlined-top {
    border-top: 1px solid rgba(151, 151, 151, 0.3);
}

.border-outlined-bottom {
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
}

.border-success-bottom {
    border-bottom: 1px solid var(--successColor);
}

.kuda-tiny--button {
    width: 50px;
    height: 27px;
    font-size: 12px;
    border-radius: 4px;
    padding: 0;
}

.utility-upload-wrap {
    min-height: 46px;
    padding: 9px 14px;
    margin-top: 12px;
}

.onboarding-avatar-inner {
    width: 70px;
    height: 70px;
}

.no-z-index {
    z-index: auto;
    z-index: initial;
}

.tag:not(body) {
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 0.375em;
    color: #4a4a4a;
    display: inline-flex;
    font-size: 0.75rem;
    height: 2em;
    justify-content: center;
    line-height: 1.5;
    padding-left: 0.75em;
    padding-right: 0.75em;
    white-space: nowrap;
    min-width: 74px;
    max-width: 74px;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.06);
}

.tag.danger {
    background-color: #f7685b;
    color: #fff;
    border: 1px solid #FAA69E;
}

.tag.warning {
    background-color: #FFC83E;
    color: #fff;
    border: 1px solid #FFE197;
}

.tag.success {
    background-color: #48D38A;
    color: #fff;
    border: 1px solid #78ECBE
}

.tag.info {
    background-color: #1DCBEF;
    color: #fff;
    border: 1px solid #7EE1F6
}

.input-text--field {
    min-height: 71px;
}

.card-group-sm {
    max-width: 142px;
    width: 100%;
}

.card-group-xs {
    max-width: 71px;
}

.shareholders-add--btn {
    background: var(--whiteColor);
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);
    border-radius: 5px;
    position: relative;
    max-width: 65px;
    width: 65px;
    padding: 5px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 48px;
    align-items: center;
    align-self: flex-end;
}

.shareholders-btn-name {
    font-size: 8px;
}

.z-index-999 {
    z-index: 9999;
}

.break-word {
    word-break: break-all;
    white-space: normal;
}

.input-range__label {
    display: none !important;
}

.input-range__track--background,
.input-range__track--active {
    height: 24px !important;
    border-radius: 20px !important;
}

.input-range__slider {
    margin: 0 !important;
    height: 42px !important;
    width: 42px !important;
    top: -34px !important;
    left: -21px !important;
    background-color: #48d38a !important;
    border: 1px solid rgba(131, 105, 160, 0.5) !important;
    box-shadow: 0px 5px 10px rgba(117, 175, 144, 0.3) !important;
}

.input-range__slider:after {
    content: "" !important;
    background: #ffffff !important;
    box-sizing: border-box !important;
    width: 13px !important;
    height: 13px !important;
    display: block !important;
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
}

.input-range__track--active {
    background-color: #48d38a !important;
}


.input-suffix-icon {
    /* width: 25%; */
    height: auto;
    background: var(--offBlue);
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: var(--blackColor);
    font-size: 24px;
    padding: 10px 20px;
    max-width: 42px;
}

.bulk-radio-wrapper {
    height: 55px;
    max-height: 55px;
}

.custom-file-input {
    /* visibility: hidden; */
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    opacity: 0;
}

.upload-bulk-wrapper {
    width: calc(100% - 42px);
}

.bulk-payment-wrap {
    max-width: 716px !important;
}

.bulk-payment-wrapMd {
    max-width: 554px !important;
}

.bulk-list-header {
    max-width: 320px;
    width: 320px;
    margin-left: auto;
    margin-right: auto;
}

.kuda-bulk--table th {
    color: #000000 !important;
}

.kuda-bulk--table tr:nth-child(even) {
    background-color: #f9fafe;
}

.multiple-transfers-header {
    max-width: 412px;
    margin: auto;
}

.bulk-beneficiaries-list {
    padding-bottom: 30px;
    /* border-bottom: 1px solid #dbdce0; */
    overflow-y: auto;
    height: auto;
    padding-top: 10px;
}

.kuda-loader--wrap.normal {
    justify-content: flex-start;
    margin-top: 30px;
}

.kuda-loader--wrap.normal .spinner-wrap {
    position: relative;
    top: auto;
    top: initial;
    left: auto;
    left: initial;
    transform: none;
    padding: 7px;
    background: #fff;
    border-radius: 100px;
    box-shadow: 0px 5px 5px rgb(0 0 0 / 5%);
    border: 1px solid var(--borderOff);
    z-index: 0;
}

.payment-note-header {
    max-width: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
}

.btn-with-icon {
    background: #ffffff;
    border: 1px solid #dfe3ff;
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 12px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.table-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f9f9f9;
    padding: 10px 57px;
}

.kuda-limit-wrap {
    max-width: 130px;
    /* max-height: 30px; */
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.03);
    border-radius: 2px;
}

.kuda-limit-wrap .amount-input {
    height: 100%;
    min-height: inherit;
}

.limit-modal-div {
    padding-top: 2px;
    padding-bottom: 2px;
}

.modal-start--top {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 999;
    overflow-y: scroll;
}

.kuda-reports--radio {
    height: auto;
    margin-bottom: 30px;
    margin-top: 0;
}

.export-date--wrap {
    background: var(--whiteColor);
    border: 1px solid var(--bgOffset);
    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);
    padding: 10px 15px;
    border-radius: 5px;
    height: 48px;
}

.account-incomplete-wrap {
    padding: 10px 29px !important;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border: 1px solid rgba(219, 220, 224, 0.5);
}

.signatories-invite--wrap {
    max-width: 533px;
    margin: auto;
}

.card-wrap--lg {
    max-width: 717;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 40px;
}

.table-btn--sm {
    background: #dfe3ff;
    border: 1px solid #000000;
    box-sizing: border-box;
    border-radius: 4px;
    color: #000000;
}

.no-bottom--borders {
    border-bottom: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.restricted-text {
    padding-bottom: 25px;
    width: 100%;
    padding-right: 25px;
    align-items: center !important;
}

.restricted-account--wrap {
    padding-top: 27px;
    padding-left: 40px;
    background: #f4e6ff;
    align-items: flex-end !important;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    margin-top: 25px;
}

.lh-18 {
    line-height: 18px;
}

.restricted-image--wrap {
    margin-right: 55px;
    height: 100%;
}

.restricted-image--wrap svg {
    width: auto;
    height: 85px;
}

.add-signatory--btn {
    min-width: 78px;
    height: 24px;
    border-radius: 3px;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
}

.addBtn-signatory--wrap {
    padding: 0px 15px !important;
    /* border: none !important; */
}

.add-signatory--label {
    padding-bottom: 13px;
}

/* .addBtn-signatory--wrap label {
  border-bottom: 1px solid #dbdce0 !important;
} */

.set-limit-badge {
    background: #dfe3ff;
    text-align: center;
    height: 40px;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 4px;
    min-width: 100px !important;
    max-width: 100px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.table-btn--sm {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0px 0px 25px rgb(0, 0, 0, 0.06);
}

.edit-save .edit-btn {
    color: #000000 !important;
    border: 1px solid #000000 !important;
    max-width: 56px !important;
    min-width: 56px !important;
}

.save-btn {
    color: #FFFFFF;
    /* border: 1px solid #48D38A; */
    background-color: #000000;
    max-width: 56px !important;
    min-width: 56px !important;
}

.disable-loader {
    top: 90px;
}

.disable-blur {
    opacity: 0.5;
}

.set-btn {
    background-color: var(--whiteAlt);
}

.manage-user-head {
    color: var(--manuge-user-heading);
}

.negative-btn .red-btn {
    color: var(--negativeColor) !important;
}

.set-transaction-input {
    display: flex;
}

.input-left {
    border-top-left-radius: 5px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 0px;
}

.input-right {
    border-top-left-radius: 0px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 5px;
}

.remove-padding {
    padding-left: 16px !important;
}

.flag-has--shadow .react-tel-input .selected-flag {
    padding-left: 13px !important;
}

.flag-has--shadow .phoneInput {
    position: relative;
    z-index: 1;
}

.grey-disabled {
    filter: grayscale(1);
    opacity: 0.4;
    pointer-events: none;
}

.disabled-item {
    filter: grayscale(1);
}

.block-item-sm .block-item {
    width: 42% !important;
}

.block-item-sm .add-signatory--wrap {
    border: 1px solid #DBDCE0 !important;
}

.y-n--dropdown .kuda-dropdown-header {
    width: 100px
}

.y-n--dropdown .kuda-dropdown-list {
    overflow-y: hidden;
    padding-top: 0px;
    margin-top: 55px;
}

.disabled-input {
    opacity: 0.2;
    pointer-events: none;
}

.form-group-row .scuml-file--upload .card-group {
    width: calc(100% - 4px);
}

.scuml-file--upload .onboarding-info--wrap .utility-upload-wrap {
    min-height: 50px;
}

.disabled-before-edit {
    opacity: 0.33;
    pointer-events: none;
}

.low-disable {
    opacity: 0.7;
    pointer-events: none;
}

.scuml-file--upload .onboarding-info--wrap .utility-upload-wrap {
    min-height: 50px;
}

/* Invoice Start */
.inventory-first-col {
    display: block;
    min-width: 160px;
    max-width: 160px;
    width: 160px;
}

.inventory-sec-col {
    display: block;
    min-width: 340px;
    max-width: 340px;
    width: 340px;
}

.inventory-search-toggle--icon {
    margin-top: 0;
    width: calc(100% - 150px) !important;
}

.dropdown-menu.inventory-dropdown {
    top: 24px !important;
    right: -28px !important;
    z-index: 2;
}

.kuda-dropdown--menu {
    background-color: var(--whiteAlt);
}

.kuda-dropdown--menu li .menu-link {
    color: var(--blackColor);
}

.kuda-dropdown--menu.inventory-dropdown-menu {
    min-width: 68px;
}

.kuda-dropdown--menu.inventory-dropdown-menu li .menu-link {
    padding: 7px 30px 8px 18px;
    background-color: var(--whiteAlt);
}

.add-invoice-icon {
    min-width: 178px;
}

.toggle-icon--button.add-customer {
    background: #000000;
    color: #FFFFFF;
}

.toggle-icon--button.add-invoice {
    white-space: nowrap;
}

.toggle-icon--button.add-invoice svg {
    height: 29px;
    width: 29px;
    display: flex;
}

/* cus - customer */
.cus-profile-col {
    display: block;
    min-width: 56px;
    max-width: 56px;
    width: 56px;
}

.cus-sec-col {
    display: block;
    min-width: 150px;
    max-width: 150px;
    width: 150px;
}

.cus-email-col {
    display: block;
    min-width: 160px;
    max-width: 160px;
    width: 160px;
}

.cus-description-col {
    display: block;
    min-width: 240px;
    max-width: 240px;
    width: 240px;
}

.cus-profile-img-container {
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 50%;
    height: 86px;
    width: 86px;
}

.cus-profile-img {
    object-fit: cover;
    object-position: center;
}

.cus-edit-btn {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 0;
}

.invoice-f-col {
    display: block;
    min-width: 350px;
    max-width: 350px;
    width: 350px;
}

.invoice-s-col {
    display: block;
    min-width: 180px;
    max-width: 180px;
    width: 180px;
}

/* Invoice End */
.sme-info--card {
    background-color: var(--whiteAlt);
}

.resend-btn {
    width: 120px !important;
    height: 30px !important;
    color: #48D38A !important;
    border: 1px solid #48D38A !important;
    background-color: #ffffff;
    border-radius: 5px !important;
}

.delete-btn {
    width: 120px !important;
    height: 30px !important;
    color: #F7685B !important;
    border: 1px solid #F7685B !important;
    background-color: #ffffff;
    border-radius: 5px !important;
}

.failed-verification-modal {
    max-width: 800px !important;
}

.resend-text {
    color: #48D38A !important;
    cursor: pointer;
}

.delete-text {
    color: #F7685B !important;
    cursor: pointer;
}

.checkbox .border {
    position: absolute;
    border: 1px solid #808080;
    border-radius: 2px;
    width: 11px;
    height: 11px;
    align-items: center;
    justify-content: center;
    vertical-align: middle !important;
}

.checkbox .indicator {
    position: absolute;
    z-index: 1;
    background: #40196D;
    width: 11px;
    height: 11px;
}

.justify-td {
    vertical-align: center;
    padding-bottom: 6px;
}

.signupv2 {
    vertical-align: center;
    min-height: calc(100vh - 100px);
    align-items: center;
    display: flex;
    padding: 63px 40px 63px 7%;
    overflow: hidden;
}

.signup-dd {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

.signup-radio {
    display: flex;
    align-items: center
}

.signup-arrow {
    display: flex;
    align-items: center;
}

.signup-dropdown {
    width: 100% !important;
    padding: 10px 32px 2px;
    font-weight: 400;
    transition: opacity 0.8s, max-height 2s;
    transform-origin: top;
    -webkit-transition: opacity 0.8s, max-height 2s;
    -moz-transition: opacity 0.8s, max-height 2s;
    -ms-transition: opacity 0.8s, max-height 2s;
    -o-transition: opacity 0.8s, max-height 2s;
}

.signup-dropdown[aria-expanded="true"] .panel__content {
    opacity: 1;
    transition: opacity 0.8s, max-height 2s;
    max-height: 100vh;
    white-space: pre-line;
}

.kuda-customer--option {
    border-bottom: 1px solid #dbdce0;
    padding: 14px 0;
}

.signup-arrow-transform {
    display: flex;
    align-items: center;
    -webkit-transition: -webkit-transform .2s;
    -webkit-transform: rotate(90deg) translateX(0);
}

.sme-kuda-cta-wide {
    width: 85% !important;
    max-width: 100% !important;
}

.negative-index-10 {
    z-index: -10;
}

.user-name {
    display: flex;
    justify-content: center;
    color: var(--blackColor);
    font-size: 20px;
    font-weight: 800;
    padding-bottom: 8px;
}

.user-email {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
}

.company-mini-profile {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
}

.company-mini-info {
    align-items: flex-start;
    width: 160px;
}

.company-mini-title {
    color: #979797;
    font-size: 13px;
    font-weight: normal;
    line-height: 18px;
    padding-bottom: 4px;
}

.company-mini-detail {
    color: var(--blackColor);
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.address-detail {
    max-width: 161px;
    flex-wrap: wrap;
}

.edit-to {
    position: absolute;
    font-size: 12px;
    display: flex;
    align-items: center;
    top: 25px;
    right: 30px;
    cursor: pointer;
}

.profile-back-button {
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    border-radius: 10px;
    justify-content: center;
    cursor: pointer;
    color: var(--primaryColor);
    background: #eff1ff;
    height: 45px;
    border: 1px solid var(--primaryColor);
    transition: transform 0.6s;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
}

.business-profile {
    margin-bottom: 70px
}

.profile-item {
    display: flex;
}

#business-img-edit-btn {
    position: relative;
    left: 17px;
    right: 71px;
    bottom: 24px;
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 100px;
    margin-left: 15px;
    cursor: pointer;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08) !important;
}

.business-img-file-input {
    position: absolute;
    top: 40px;
    left: 300px;
    right: 0;
    bottom: 0;
    width: 100px;
    height: 100px;
    opacity: 0;
    cursor: pointer;
    z-index: 9;
}

.business-unverified {
    border: 1px solid rgba(219, 220, 224, 0.5);
    background-color: #FFF5DB;
    border-radius: 5px 5px 5px 5px;
    height: 30px;
    font-size: 7px;
    align-items: center;
    display: flex;
}

.business-unverified-text {
    font-size: 9px;
    padding-top: 7px;
    color: #5d5a5a;

}

.caution-icon {
    padding-top: 14px;
    padding-right: 20px;
}

.hr-line {
    height: 1px;
    color: #5d5a5a;
    opacity: 0.3
}

.unverified-account {
    max-width: 391px;
    max-width: 100%;
    border: 1px solid rgba(219, 220, 224, 0.5);
    border-radius: 5px;
    padding: 11px 19px;
    min-height: 73px;
    display: flex;
    align-items: center;
    width: 100% !important;
    margin-top: 17px !important;
}

.bold-cac-number {
    font-weight: bold;
}

.center-item {
    display: flex;
    justify-content: center;
    margin-top: 25px
}

.business-unverified-item {
    border: 1px solid rgba(219, 220, 224, 0.5);
    background-color: #FFF5DB;
    border-radius: 5px 5px 5px 5px;
    height: 30px;
    font-size: 7px;
    align-items: center;
    display: flex;
    padding: 17px;
}

.business-unverified-text-item {
    font-size: 0.825rem;
    color: #5d5a5a;
    white-space: nowrap;
    font-weight: 500;
}

.select-bus-profile .kuda-radio--lgWrap input:not(:checked)+label {
    color: var(--blackColor);
    background-color: transparent !important;
}

.delete-btn-text {
    font-weight: normal;
    font-size: 15px;
    line-height: 15px;
    text-align: center;
}

.resend-btn-text {
    font-weight: normal;
    font-size: 15px;
    line-height: 15px;
    text-align: center;
}

.bulk-beneficiaries-list::-webkit-scrollbar {
    width: 3px;
}

.bulk-beneficiaries-list::-webkit-scrollbar-thumb {
    background-color: #40196D;
    border-radius: 25px;
}

.bulk-beneficiaries-list::-webkit-scrollbar-track {
    background-color: #CACACA;
}

.bulk-transaction-modal {
    max-width: 600px !important;
}

.bulk-narration {
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #000000;
}

.description-box {
    padding-top: 20px;
    justify-content: center;
}

.beneficiaries-view-btn {
    font-size: 14px;
    height: 30px;
    width: 100%;
}

.mt25 {
    margin-top: 25px;
}

.signup-text {
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
}

.counter-info {
    position: absolute;
    font-size: 12px;
    display: flex;
    align-items: center;
    top: 5px;
    right: 30px;
    cursor: pointer;
}

.document-title {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #333333;
    width: 300px;
    margin: auto;
}

.document-sub-title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
    color: #979797;
    margin: auto auto 35px !important;
}

.icon-md .bill-item--icon svg {
    height: 30px;
    width: auto;
}

.icon-md {
    height: 56px;
}

.bulk-transaction-modal .bank-summary--result {
    max-height: calc(100vh - 400px);
    overflow-x: hidden;
}

.bulk-list--scroll {
    max-height: calc(100vh - 520px);
    overflow-x: hidden;
}

.terms--wrap {
    margin-top: 35px;
    color: var(--blackColor)
}

.terms--wrap h3 {
    line-height: 1.35;
}

td br {
    display: block;
    /* makes it have a width */
    content: "";
    /* clears default height */
    margin-top: 9px;
    /* change this to whatever height you want it */
}

.business-name--heading {
    line-height: 1.4;
}

.bulk-beneficiaries-list,
.bulk-success-modal-list {
    max-height: calc(100vh - 605px);
}

.checklist li {
    font-size: 0.975rem;
    line-height: 1.4;
}

.checklist li:not(:last-child) {
    margin-bottom: 20px;
}

.terms--wrap p {
    margin-bottom: 20px
}

.terms--wrap h3 {
    font-size: 1.45rem
}

.mt-44 {
    margin-top: 44px;
}

.error-auth--label {
    font-weight: 700;
    font-size: 0.835rem;
    line-height: 1.3;
}

.margin-auto {
    margin: auto
}

.bg-white {
    background: #ffffff !important;
}

.hide-btn {
    display: none
}

.disable-dead {
    background: #CACACA !important;
    pointer-events: none;
}
.disable--red-dead {
    opacity: 0.5;
    pointer-events: none;
}
.account-balance-spinner .spinner-wrap {
    top: 0px !important;
}
.beneficiariesIcon >svg{
    height: 9px;
    width: 9px;
}
.switch-dropdown .account-name {
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 256px; */
    display: flex;
    white-space: break-spaces;
    word-break: break-all;
    max-width: 256px;
}

.login-container--wrap {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 100%;
    min-height: 100vh;
    overflow: hidden;
}

.no-padding .formInput {
    padding-left: 0px !important;
}
.bill-itemm {
    background: #FFFFFF;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    border: none;
}

@media only screen and (max-width: 768px) {
    .text-invisible {
        font-size: 0;
    }
    .random-placeholder {
        margin-right: 10px;
    }
    .placeholder-2 {
        padding-right: 5px;
    }
    .placeholder-3 {
        align-items: center;
    }
}

@media only screen and (max-width: 767px) {
    .icon--bottom--spacer{
        height: 52px;
        margin-left: 0px;
        margin-right: 0px;
        margin-top: -3px;
        margin-bottom: 1px;
    }
}

.auth-border-bottom {
    border-bottom: #000000 solid 3px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/sme.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;;AAEzB;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,+CAA+C;;AAE/C;IACI,sBAAsB;AAC1B;;AAEA,wDAAwD;;AAExD;IACI,yBAAyB;AAC7B;;AAEA,6DAA6D;;AAE7D;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA,oCAAoC;;AAEpC;IACI,cAAc;AAClB;;AAEA,kCAAkC;;AAElC;IACI,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IAGzB,wBAAwB;AAC5B;;AAEA,6BAA6B;;AAE7B;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,4CAA4C;IAC5C,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAU;IAAV,YAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;;IAGI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,uDAAuD;IACvD,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAc;IAAd,gBAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;IACjC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,qDAAqD;IACrD,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,wCAAwC;IACxC,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,sCAAsC;IACtC,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAU;IAAV,YAAU;IACV,UAAW;IAAX,aAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,uCAAuC;IACvC,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;IACjC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;GAEG;;AAEH;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,uCAAuC;IACvC,qBAAqB;IACrB,+CAA+C;IAC/C,4CAA4C;IAC5C,2CAA2C;IAC3C,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,qCAAqC;IACrC,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,UAAU;IACV,eAAe;IACf,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI;;;uBAGmB;IACnB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yDAA8C;IAC9C,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".w-48 {\n    width: 48%;\n}\n\n.text-capitalize {\n    text-transform: capitalize;\n}\n\n.no-visible {\n    visibility: hidden;\n}\n\n.no-resize {\n    resize: none;\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.overflow-x-scroll {\n    overflow-x: scroll;\n}\n\n.invisible {\n    visibility: hidden;\n}\n\n.clip-text {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n    width: calc(100%);\n    -webkit-hyphens: auto;\n    hyphens: auto;\n}\n\n.clamp-2 {\n    -webkit-line-clamp: 2;\n}\n\n.description-word-length {\n    position: absolute;\n    right: 5px;\n    bottom: 5px;\n    font-size: 12px;\n}\n\n.overflow-wrap-anywhere {\n    overflow-wrap: anywhere;\n}\n\n.whitespace-nowrap {\n    white-space: nowrap;\n}\n\n/* ----- CHECKBOX ----- */\n\n.checkbox-wrap {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 22px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.checkbox-wrap input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 9px;\n    width: 9px;\n    background-color: #fff;\n    border: 1px solid #000000;\n    border-radius: 2px;\n}\n\n/* On mouse-over, add a grey background color */\n\n.checkbox-wrap:hover input~.checkmark {\n    background-color: #ccc;\n}\n\n/* When the checkbox is checked, add a blue background */\n\n.checkbox-wrap input:checked~.checkmark {\n    background-color: #000000;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n\n.checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n\n/* Show the checkmark when checked */\n\n.checkbox-wrap input:checked~.checkmark:after {\n    display: block;\n}\n\n/* Style the checkmark/indicator */\n\n.checkbox-wrap .checkmark:after {\n    left: 9px;\n    top: 5px;\n    width: 3px;\n    height: 5px;\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n\n/* --- MANAGE BENEFICIARIES */\n\n.kuda-beneficiary--card {\n    max-width: 533px !important;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.beneficairy-info--wrap {\n    max-width: 380px;\n    display: flex;\n    margin: auto;\n    flex-direction: column;\n}\n\n.beneficiary-history {\n    border-top: 1px solid rgba(5, 96, 117, 0.08);\n    padding-right: 0;\n    margin-top: 34px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n    position: relative;\n}\n\n.beneficiary-profile-image {\n    width: 80px;\n    height: 80px;\n    display: flex;\n    background-size: cover;\n    background-color: #e8e8e8;\n    border-radius: 100px;\n    margin-bottom: 10px;\n}\n\n.no-beneficiary-msg {\n    font-size: 20px;\n    text-align: center;\n    margin-top: 92px;\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.beneficiary-transactions--loaderWrap {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.beneficiary-loader--wrap {\n    margin-top: 50px;\n}\n\n.beneficiary-loader {\n    top: unset;\n}\n\nthead th {\n    color: #979797 !important;\n}\n\n.analytics-transaction--details p {\n    max-width: 335px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 20px;\n}\n\n.kuda-signatory--table td {\n    font-size: 0.875rem;\n}\n\n.kuda-signatory--table td:last-child {\n    padding-right: 15px;\n}\n\n.no-left {\n    left: 0 !important;\n}\n\n.schedule-item {\n    width: 100%;\n}\n\n.schedule-time-wrap {\n    height: 46px;\n    margin-top: 3px;\n}\n\n.schedule-time--dropdown {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    border-right: 1px solid #dfe3ff;\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: 0 10px;\n}\n\n.schedule-dropdown--title {\n    font-size: 12px;\n    padding-right: 0px;\n    padding-left: 5px;\n}\n\n.scheduleTime-dropdown-icon,\n.scheduleTime-dropdown-header,\n.schedule-dropdown--title {\n    width: fit-content !important;\n}\n\n.schedule-time--wrap {\n    width: 145px;\n    max-width: 145px;\n}\n\n.scheduleTime-dropdown-list {\n    max-width: 62px;\n    /* background: transparent; */\n}\n\n.schedule-time-input {\n    width: 70px;\n}\n\n.schedule-time-input input {\n    width: 25px;\n    border: none;\n    outline: none;\n}\n\n.width-fit-content {\n    width: fit-content !important;\n}\n\n.onboarding-info--wrap {\n    max-width: 560px;\n    /* margin: 0 auto; */\n    width: 100%;\n}\n\n.card-display--bio {\n    background: #ffffff;\n    border: 1px solid #dfe3ff !important;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06) !important;\n    border-radius: 4px;\n    height: 100%;\n    width: 100%;\n    max-width: 356px;\n    padding: 21px 30px;\n    margin-top: 2.375rem;\n    margin-bottom: 1.875rem;\n}\n\n.onboarding-avatar {\n    width: 70px;\n    height: 70px;\n    min-width: 70px;\n    background: #dfe4ff;\n}\n\n.border-outlined-top {\n    border-top: 1px solid rgba(151, 151, 151, 0.3);\n}\n\n.border-outlined-bottom {\n    border-bottom: 1px solid rgba(151, 151, 151, 0.3);\n}\n\n.border-success-bottom {\n    border-bottom: 1px solid var(--successColor);\n}\n\n.kuda-tiny--button {\n    width: 50px;\n    height: 27px;\n    font-size: 12px;\n    border-radius: 4px;\n    padding: 0;\n}\n\n.utility-upload-wrap {\n    min-height: 46px;\n    padding: 9px 14px;\n    margin-top: 12px;\n}\n\n.onboarding-avatar-inner {\n    width: 70px;\n    height: 70px;\n}\n\n.no-z-index {\n    z-index: unset;\n}\n\n.tag:not(body) {\n    align-items: center;\n    background-color: #f5f5f5;\n    border-radius: 0.375em;\n    color: #4a4a4a;\n    display: inline-flex;\n    font-size: 0.75rem;\n    height: 2em;\n    justify-content: center;\n    line-height: 1.5;\n    padding-left: 0.75em;\n    padding-right: 0.75em;\n    white-space: nowrap;\n    min-width: 74px;\n    max-width: 74px;\n    box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.06);\n}\n\n.tag.danger {\n    background-color: #f7685b;\n    color: #fff;\n    border: 1px solid #FAA69E;\n}\n\n.tag.warning {\n    background-color: #FFC83E;\n    color: #fff;\n    border: 1px solid #FFE197;\n}\n\n.tag.success {\n    background-color: #48D38A;\n    color: #fff;\n    border: 1px solid #78ECBE\n}\n\n.tag.info {\n    background-color: #1DCBEF;\n    color: #fff;\n    border: 1px solid #7EE1F6\n}\n\n.input-text--field {\n    min-height: 71px;\n}\n\n.card-group-sm {\n    max-width: 142px;\n    width: 100%;\n}\n\n.card-group-xs {\n    max-width: 71px;\n}\n\n.shareholders-add--btn {\n    background: var(--whiteColor);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);\n    border-radius: 5px;\n    position: relative;\n    max-width: 65px;\n    width: 65px;\n    padding: 5px 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 48px;\n    align-items: center;\n    align-self: flex-end;\n}\n\n.shareholders-btn-name {\n    font-size: 8px;\n}\n\n.z-index-999 {\n    z-index: 9999;\n}\n\n.break-word {\n    word-break: break-all;\n    white-space: normal;\n}\n\n.input-range__label {\n    display: none !important;\n}\n\n.input-range__track--background,\n.input-range__track--active {\n    height: 24px !important;\n    border-radius: 20px !important;\n}\n\n.input-range__slider {\n    margin: 0 !important;\n    height: 42px !important;\n    width: 42px !important;\n    top: -34px !important;\n    left: -21px !important;\n    background-color: #48d38a !important;\n    border: 1px solid rgba(131, 105, 160, 0.5) !important;\n    box-shadow: 0px 5px 10px rgba(117, 175, 144, 0.3) !important;\n}\n\n.input-range__slider:after {\n    content: \"\" !important;\n    background: #ffffff !important;\n    box-sizing: border-box !important;\n    width: 13px !important;\n    height: 13px !important;\n    display: block !important;\n    position: absolute !important;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.input-range__track--active {\n    background-color: #48d38a !important;\n}\n\n\n.input-suffix-icon {\n    /* width: 25%; */\n    height: auto;\n    background: var(--offBlue);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);\n    border-radius: 5px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    color: var(--blackColor);\n    font-size: 24px;\n    padding: 10px 20px;\n    max-width: 42px;\n}\n\n.bulk-radio-wrapper {\n    height: 55px;\n    max-height: 55px;\n}\n\n.custom-file-input {\n    /* visibility: hidden; */\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    opacity: 0;\n}\n\n.upload-bulk-wrapper {\n    width: calc(100% - 42px);\n}\n\n.bulk-payment-wrap {\n    max-width: 716px !important;\n}\n\n.bulk-payment-wrapMd {\n    max-width: 554px !important;\n}\n\n.bulk-list-header {\n    max-width: 320px;\n    width: 320px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.kuda-bulk--table th {\n    color: #000000 !important;\n}\n\n.kuda-bulk--table tr:nth-child(even) {\n    background-color: #f9fafe;\n}\n\n.multiple-transfers-header {\n    max-width: 412px;\n    margin: auto;\n}\n\n.bulk-beneficiaries-list {\n    padding-bottom: 30px;\n    /* border-bottom: 1px solid #dbdce0; */\n    overflow-y: auto;\n    height: auto;\n    padding-top: 10px;\n}\n\n.kuda-loader--wrap.normal {\n    justify-content: flex-start;\n    margin-top: 30px;\n}\n\n.kuda-loader--wrap.normal .spinner-wrap {\n    position: relative;\n    top: unset;\n    left: unset;\n    transform: none;\n    padding: 7px;\n    background: #fff;\n    border-radius: 100px;\n    box-shadow: 0px 5px 5px rgb(0 0 0 / 5%);\n    border: 1px solid var(--borderOff);\n    z-index: 0;\n}\n\n.payment-note-header {\n    max-width: 260px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.btn-with-icon {\n    background: #ffffff;\n    border: 1px solid #dfe3ff;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    padding: 12px 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.table-div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f9f9f9;\n    padding: 10px 57px;\n}\n\n.kuda-limit-wrap {\n    max-width: 130px;\n    /* max-height: 30px; */\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.03);\n    border-radius: 2px;\n}\n\n.kuda-limit-wrap .amount-input {\n    height: 100%;\n    min-height: inherit;\n}\n\n.limit-modal-div {\n    padding-top: 2px;\n    padding-bottom: 2px;\n}\n\n.modal-start--top {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    z-index: 999;\n    overflow-y: scroll;\n}\n\n.kuda-reports--radio {\n    height: auto;\n    margin-bottom: 30px;\n    margin-top: 0;\n}\n\n.export-date--wrap {\n    background: var(--whiteColor);\n    border: 1px solid var(--bgOffset);\n    box-shadow: 0px 2px 2px rgb(0 0 0 / 10%);\n    padding: 10px 15px;\n    border-radius: 5px;\n    height: 48px;\n}\n\n.account-incomplete-wrap {\n    padding: 10px 29px !important;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n}\n\n.signatories-invite--wrap {\n    max-width: 533px;\n    margin: auto;\n}\n\n.card-wrap--lg {\n    max-width: 717;\n    padding-left: 0px;\n    padding-right: 0px;\n    padding-top: 40px;\n}\n\n.table-btn--sm {\n    background: #dfe3ff;\n    border: 1px solid #000000;\n    box-sizing: border-box;\n    border-radius: 4px;\n    color: #000000;\n}\n\n.no-bottom--borders {\n    border-bottom: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.restricted-text {\n    padding-bottom: 25px;\n    width: 100%;\n    padding-right: 25px;\n    align-items: center !important;\n}\n\n.restricted-account--wrap {\n    padding-top: 27px;\n    padding-left: 40px;\n    background: #f4e6ff;\n    align-items: flex-end !important;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);\n    border-radius: 5px;\n    margin-top: 25px;\n}\n\n.lh-18 {\n    line-height: 18px;\n}\n\n.restricted-image--wrap {\n    margin-right: 55px;\n    height: 100%;\n}\n\n.restricted-image--wrap svg {\n    width: auto;\n    height: 85px;\n}\n\n.add-signatory--btn {\n    min-width: 78px;\n    height: 24px;\n    border-radius: 3px;\n    font-size: 11px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 11px;\n}\n\n.addBtn-signatory--wrap {\n    padding: 0px 15px !important;\n    /* border: none !important; */\n}\n\n.add-signatory--label {\n    padding-bottom: 13px;\n}\n\n/* .addBtn-signatory--wrap label {\n  border-bottom: 1px solid #dbdce0 !important;\n} */\n\n.set-limit-badge {\n    background: #dfe3ff;\n    text-align: center;\n    height: 40px;\n    justify-content: center;\n    box-sizing: border-box;\n    border-radius: 4px;\n    min-width: 100px !important;\n    max-width: 100px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.table-btn--sm {\n    background: #ffffff;\n    box-sizing: border-box;\n    border-radius: 4px;\n    box-shadow: 0px 0px 25px rgb(0, 0, 0, 0.06);\n}\n\n.edit-save .edit-btn {\n    color: #000000 !important;\n    border: 1px solid #000000 !important;\n    max-width: 56px !important;\n    min-width: 56px !important;\n}\n\n.save-btn {\n    color: #FFFFFF;\n    /* border: 1px solid #48D38A; */\n    background-color: #000000;\n    max-width: 56px !important;\n    min-width: 56px !important;\n}\n\n.disable-loader {\n    top: 90px;\n}\n\n.disable-blur {\n    opacity: 0.5;\n}\n\n.set-btn {\n    background-color: var(--whiteAlt);\n}\n\n.manage-user-head {\n    color: var(--manuge-user-heading);\n}\n\n.negative-btn .red-btn {\n    color: var(--negativeColor) !important;\n}\n\n.set-transaction-input {\n    display: flex;\n}\n\n.input-left {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 0px;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 0px;\n}\n\n.input-right {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 5px;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 5px;\n}\n\n.remove-padding {\n    padding-left: 16px !important;\n}\n\n.flag-has--shadow .react-tel-input .selected-flag {\n    padding-left: 13px !important;\n}\n\n.flag-has--shadow .phoneInput {\n    position: relative;\n    z-index: 1;\n}\n\n.grey-disabled {\n    filter: grayscale(1);\n    opacity: 0.4;\n    pointer-events: none;\n}\n\n.disabled-item {\n    filter: grayscale(1);\n}\n\n.block-item-sm .block-item {\n    width: 42% !important;\n}\n\n.block-item-sm .add-signatory--wrap {\n    border: 1px solid #DBDCE0 !important;\n}\n\n.y-n--dropdown .kuda-dropdown-header {\n    width: 100px\n}\n\n.y-n--dropdown .kuda-dropdown-list {\n    overflow-y: hidden;\n    padding-top: 0px;\n    margin-top: 55px;\n}\n\n.disabled-input {\n    opacity: 0.2;\n    pointer-events: none;\n}\n\n.form-group-row .scuml-file--upload .card-group {\n    width: calc(100% - 4px);\n}\n\n.scuml-file--upload .onboarding-info--wrap .utility-upload-wrap {\n    min-height: 50px;\n}\n\n.disabled-before-edit {\n    opacity: 0.33;\n    pointer-events: none;\n}\n\n.low-disable {\n    opacity: 0.7;\n    pointer-events: none;\n}\n\n.scuml-file--upload .onboarding-info--wrap .utility-upload-wrap {\n    min-height: 50px;\n}\n\n/* Invoice Start */\n.inventory-first-col {\n    display: block;\n    min-width: 160px;\n    max-width: 160px;\n    width: 160px;\n}\n\n.inventory-sec-col {\n    display: block;\n    min-width: 340px;\n    max-width: 340px;\n    width: 340px;\n}\n\n.inventory-search-toggle--icon {\n    margin-top: 0;\n    width: calc(100% - 150px) !important;\n}\n\n.dropdown-menu.inventory-dropdown {\n    top: 24px !important;\n    right: -28px !important;\n    z-index: 2;\n}\n\n.kuda-dropdown--menu {\n    background-color: var(--whiteAlt);\n}\n\n.kuda-dropdown--menu li .menu-link {\n    color: var(--blackColor);\n}\n\n.kuda-dropdown--menu.inventory-dropdown-menu {\n    min-width: 68px;\n}\n\n.kuda-dropdown--menu.inventory-dropdown-menu li .menu-link {\n    padding: 7px 30px 8px 18px;\n    background-color: var(--whiteAlt);\n}\n\n.add-invoice-icon {\n    min-width: 178px;\n}\n\n.toggle-icon--button.add-customer {\n    background: #000000;\n    color: #FFFFFF;\n}\n\n.toggle-icon--button.add-invoice {\n    white-space: nowrap;\n}\n\n.toggle-icon--button.add-invoice svg {\n    height: 29px;\n    width: 29px;\n    display: flex;\n}\n\n/* cus - customer */\n.cus-profile-col {\n    display: block;\n    min-width: 56px;\n    max-width: 56px;\n    width: 56px;\n}\n\n.cus-sec-col {\n    display: block;\n    min-width: 150px;\n    max-width: 150px;\n    width: 150px;\n}\n\n.cus-email-col {\n    display: block;\n    min-width: 160px;\n    max-width: 160px;\n    width: 160px;\n}\n\n.cus-description-col {\n    display: block;\n    min-width: 240px;\n    max-width: 240px;\n    width: 240px;\n}\n\n.cus-profile-img-container {\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 50%;\n    height: 86px;\n    width: 86px;\n}\n\n.cus-profile-img {\n    object-fit: cover;\n    object-position: center;\n}\n\n.cus-edit-btn {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.invoice-f-col {\n    display: block;\n    min-width: 350px;\n    max-width: 350px;\n    width: 350px;\n}\n\n.invoice-s-col {\n    display: block;\n    min-width: 180px;\n    max-width: 180px;\n    width: 180px;\n}\n\n/* Invoice End */\n.sme-info--card {\n    background-color: var(--whiteAlt);\n}\n\n.resend-btn {\n    width: 120px !important;\n    height: 30px !important;\n    color: #48D38A !important;\n    border: 1px solid #48D38A !important;\n    background-color: #ffffff;\n    border-radius: 5px !important;\n}\n\n.delete-btn {\n    width: 120px !important;\n    height: 30px !important;\n    color: #F7685B !important;\n    border: 1px solid #F7685B !important;\n    background-color: #ffffff;\n    border-radius: 5px !important;\n}\n\n.failed-verification-modal {\n    max-width: 800px !important;\n}\n\n.resend-text {\n    color: #48D38A !important;\n    cursor: pointer;\n}\n\n.delete-text {\n    color: #F7685B !important;\n    cursor: pointer;\n}\n\n.checkbox .border {\n    position: absolute;\n    border: 1px solid #808080;\n    border-radius: 2px;\n    width: 11px;\n    height: 11px;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle !important;\n}\n\n.checkbox .indicator {\n    position: absolute;\n    z-index: 1;\n    background: #40196D;\n    width: 11px;\n    height: 11px;\n}\n\n.justify-td {\n    vertical-align: center;\n    padding-bottom: 6px;\n}\n\n.signupv2 {\n    vertical-align: center;\n    min-height: calc(100vh - 100px);\n    align-items: center;\n    display: flex;\n    padding: 63px 40px 63px 7%;\n    overflow: hidden;\n}\n\n.signup-dd {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n}\n\n.signup-radio {\n    display: flex;\n    align-items: center\n}\n\n.signup-arrow {\n    display: flex;\n    align-items: center;\n}\n\n.signup-dropdown {\n    width: 100% !important;\n    padding: 10px 32px 2px;\n    font-weight: 400;\n    transition: opacity 0.8s, max-height 2s;\n    transform-origin: top;\n    -webkit-transition: opacity 0.8s, max-height 2s;\n    -moz-transition: opacity 0.8s, max-height 2s;\n    -ms-transition: opacity 0.8s, max-height 2s;\n    -o-transition: opacity 0.8s, max-height 2s;\n}\n\n.signup-dropdown[aria-expanded=\"true\"] .panel__content {\n    opacity: 1;\n    transition: opacity 0.8s, max-height 2s;\n    max-height: 100vh;\n    white-space: pre-line;\n}\n\n.kuda-customer--option {\n    border-bottom: 1px solid #dbdce0;\n    padding: 14px 0;\n}\n\n.signup-arrow-transform {\n    display: flex;\n    align-items: center;\n    -webkit-transition: -webkit-transform .2s;\n    -webkit-transform: rotate(90deg) translateX(0);\n}\n\n.sme-kuda-cta-wide {\n    width: 85% !important;\n    max-width: 100% !important;\n}\n\n.negative-index-10 {\n    z-index: -10;\n}\n\n.user-name {\n    display: flex;\n    justify-content: center;\n    color: var(--blackColor);\n    font-size: 20px;\n    font-weight: 800;\n    padding-bottom: 8px;\n}\n\n.user-email {\n    display: flex;\n    justify-content: center;\n    padding-bottom: 30px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n}\n\n.company-mini-profile {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 40px;\n}\n\n.company-mini-info {\n    align-items: flex-start;\n    width: 160px;\n}\n\n.company-mini-title {\n    color: #979797;\n    font-size: 13px;\n    font-weight: normal;\n    line-height: 18px;\n    padding-bottom: 4px;\n}\n\n.company-mini-detail {\n    color: var(--blackColor);\n    font-size: 14px;\n    font-weight: bold;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.address-detail {\n    max-width: 161px;\n    flex-wrap: wrap;\n}\n\n.edit-to {\n    position: absolute;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    top: 25px;\n    right: 30px;\n    cursor: pointer;\n}\n\n.profile-back-button {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    padding: 15px 15px;\n    border-radius: 10px;\n    justify-content: center;\n    cursor: pointer;\n    color: var(--primaryColor);\n    background: #eff1ff;\n    height: 45px;\n    border: 1px solid var(--primaryColor);\n    transition: transform 0.6s;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n}\n\n.business-profile {\n    margin-bottom: 70px\n}\n\n.profile-item {\n    display: flex;\n}\n\n#business-img-edit-btn {\n    position: relative;\n    left: 17px;\n    right: 71px;\n    bottom: 24px;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    border-radius: 100px;\n    margin-left: 15px;\n    cursor: pointer;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08) !important;\n}\n\n.business-img-file-input {\n    position: absolute;\n    top: 40px;\n    left: 300px;\n    right: 0;\n    bottom: 0;\n    width: 100px;\n    height: 100px;\n    opacity: 0;\n    cursor: pointer;\n    z-index: 9;\n}\n\n.business-unverified {\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    background-color: #FFF5DB;\n    border-radius: 5px 5px 5px 5px;\n    height: 30px;\n    font-size: 7px;\n    align-items: center;\n    display: flex;\n}\n\n.business-unverified-text {\n    font-size: 9px;\n    padding-top: 7px;\n    color: #5d5a5a;\n\n}\n\n.caution-icon {\n    padding-top: 14px;\n    padding-right: 20px;\n}\n\n.hr-line {\n    height: 1px;\n    color: #5d5a5a;\n    opacity: 0.3\n}\n\n.unverified-account {\n    max-width: 391px;\n    max-width: 100%;\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    border-radius: 5px;\n    padding: 11px 19px;\n    min-height: 73px;\n    display: flex;\n    align-items: center;\n    width: 100% !important;\n    margin-top: 17px !important;\n}\n\n.bold-cac-number {\n    font-weight: bold;\n}\n\n.center-item {\n    display: flex;\n    justify-content: center;\n    margin-top: 25px\n}\n\n.business-unverified-item {\n    border: 1px solid rgba(219, 220, 224, 0.5);\n    background-color: #FFF5DB;\n    border-radius: 5px 5px 5px 5px;\n    height: 30px;\n    font-size: 7px;\n    align-items: center;\n    display: flex;\n    padding: 17px;\n}\n\n.business-unverified-text-item {\n    font-size: 0.825rem;\n    color: #5d5a5a;\n    white-space: nowrap;\n    font-weight: 500;\n}\n\n.select-bus-profile .kuda-radio--lgWrap input:not(:checked)+label {\n    color: var(--blackColor);\n    background-color: transparent !important;\n}\n\n.delete-btn-text {\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 15px;\n    text-align: center;\n}\n\n.resend-btn-text {\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 15px;\n    text-align: center;\n}\n\n.bulk-beneficiaries-list::-webkit-scrollbar {\n    width: 3px;\n}\n\n.bulk-beneficiaries-list::-webkit-scrollbar-thumb {\n    background-color: #40196D;\n    border-radius: 25px;\n}\n\n.bulk-beneficiaries-list::-webkit-scrollbar-track {\n    background-color: #CACACA;\n}\n\n.bulk-transaction-modal {\n    max-width: 600px !important;\n}\n\n.bulk-narration {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 16px;\n    text-align: center;\n    color: #000000;\n}\n\n.description-box {\n    padding-top: 20px;\n    justify-content: center;\n}\n\n.beneficiaries-view-btn {\n    font-size: 14px;\n    height: 30px;\n    width: 100%;\n}\n\n.mt25 {\n    margin-top: 25px;\n}\n\n.signup-text {\n    font-style: normal;\n    font-weight: 900;\n    font-size: 20px;\n}\n\n.counter-info {\n    position: absolute;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    top: 5px;\n    right: 30px;\n    cursor: pointer;\n}\n\n.document-title {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #333333;\n    width: 300px;\n    margin: auto;\n}\n\n.document-sub-title {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n    line-height: 20px;\n    text-align: center;\n    color: #979797;\n    margin: auto auto 35px !important;\n}\n\n.icon-md .bill-item--icon svg {\n    height: 30px;\n    width: auto;\n}\n\n.icon-md {\n    height: 56px;\n}\n\n.bulk-transaction-modal .bank-summary--result {\n    max-height: calc(100vh - 400px);\n    overflow-x: hidden;\n}\n\n.bulk-list--scroll {\n    max-height: calc(100vh - 520px);\n    overflow-x: hidden;\n}\n\n.terms--wrap {\n    margin-top: 35px;\n    color: var(--blackColor)\n}\n\n.terms--wrap h3 {\n    line-height: 1.35;\n}\n\ntd br {\n    display: block;\n    /* makes it have a width */\n    content: \"\";\n    /* clears default height */\n    margin-top: 9px;\n    /* change this to whatever height you want it */\n}\n\n.business-name--heading {\n    line-height: 1.4;\n}\n\n.bulk-beneficiaries-list,\n.bulk-success-modal-list {\n    max-height: calc(100vh - 605px);\n}\n\n.checklist li {\n    font-size: 0.975rem;\n    line-height: 1.4;\n}\n\n.checklist li:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.terms--wrap p {\n    margin-bottom: 20px\n}\n\n.terms--wrap h3 {\n    font-size: 1.45rem\n}\n\n.mt-44 {\n    margin-top: 44px;\n}\n\n.error-auth--label {\n    font-weight: 700;\n    font-size: 0.835rem;\n    line-height: 1.3;\n}\n\n.margin-auto {\n    margin: auto\n}\n\n.bg-white {\n    background: #ffffff !important;\n}\n\n.hide-btn {\n    display: none\n}\n\n.disable-dead {\n    background: #CACACA !important;\n    pointer-events: none;\n}\n.disable--red-dead {\n    opacity: 0.5;\n    pointer-events: none;\n}\n.account-balance-spinner .spinner-wrap {\n    top: 0px !important;\n}\n.beneficiariesIcon >svg{\n    height: 9px;\n    width: 9px;\n}\n.switch-dropdown .account-name {\n    /* white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 256px; */\n    display: flex;\n    white-space: break-spaces;\n    word-break: break-all;\n    max-width: 256px;\n}\n\n.login-container--wrap {\n    background-image: url(\"../img/home-lines.svg\");\n    background-repeat: no-repeat;\n    background-position: bottom;\n    background-size: 100%;\n    min-height: 100vh;\n    overflow: hidden;\n}\n\n.no-padding .formInput {\n    padding-left: 0px !important;\n}\n.bill-itemm {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.06);\n    border-radius: 4px;\n    border: none;\n}\n\n@media only screen and (max-width: 768px) {\n    .text-invisible {\n        font-size: 0;\n    }\n    .random-placeholder {\n        margin-right: 10px;\n    }\n    .placeholder-2 {\n        padding-right: 5px;\n    }\n    .placeholder-3 {\n        align-items: center;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .icon--bottom--spacer{\n        height: 52px;\n        margin-left: 0px;\n        margin-right: 0px;\n        margin-top: -3px;\n        margin-bottom: 1px;\n    }\n}\n\n.auth-border-bottom {\n    border-bottom: #000000 solid 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
